import React, { useEffect, useState } from "react";
import NoFooterModal from "../../Common/NoFooterModal";
import Button from "sushiweb/Button";
import Input from "sushiweb/InputTypes/Input";
import {
  capitalizeFirstLetter,
  isObjectAllEntriesPresent,
} from "../../../utils";
import { BottomSectionModal } from "../../../constants/assets/containers";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as DeliveryDriversActions from "../../../store/actions/DeliveryDrivers";
import * as UserActions from "../../../store/actions/User";
import variables from "../../../constants/assets/variables";
import Textarea from "sushiweb/InputTypes/Textarea";
import VerifyDriverDocument, {
  requiredDocs,
} from "../../../components/DeliveryDrivers/VerifyDriver";
import { validateDriverDocuments } from "../../../components/DeliveryDrivers/VerifyDriver/validations";

const DriverActionModal = ({
  driverDocuments,
  action,
  handleClose,
  getDriverActionReasons,
  terminateDriver,
  resignDriver,
  notifyDriver,
  driverActionReasons,
  forceOfflineDriver,
  clearSelfieCampaignDriver,
  getDriverDocuments,
  verifyDriverDocuments,
  updateDriverDocumentsDetails,
  allMenuActions,
}) => {
  const requiredDocs = [
    "license_doc",
    "pan_card_doc",
    "identity_proof_doc",
    "bank_doc",
    "image",
  ];
  const { id } = useParams();
  const [reasonId, setReasonId] = useState("");
  const [notifyState, setNotifyState] = useState({
    type: "",
    title: "",
    message: "",
  });
  const [saveState, setSaveState] = useState(false);
  const [editState, setEditState] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [uploadingFiles, setUploadingFiles] = useState({});
  const [errors, setErrors] = useState([]);
  const [triggerDirectUpload, setTriggerDirectUpload] = useState(true);

  const handleEditCancel = () => {
    setEditState(false);
  };

  const handleDocumentSubmit = (payload) => {
    const err = validateDriverDocuments(uploadingFiles);
    setErrors(err);
    if (err.length > 0) {
      setSaveState(false);
    } else {
      setTriggerDirectUpload(true);

      updateDriverDocumentsDetails(id, uploadingFiles)
        .then((_response) => {
          setSaveState(false);
          verifyDriverDocuments(payload);
          getDriverDocuments(id, { documents: requiredDocs });
        })
        .catch((_error) => {
          setSaveState(false);
        })
        .finally(() => {
          setTriggerDirectUpload(false);
        });
    }
  };

  const handleDocumentsVerify = (payload) => {
    const err = validateDriverDocuments(uploadingFiles);
    setErrors(err);
    if (err.length > 0) {
      setSaveState(false);
    } else {
      setTriggerDirectUpload(true);

      verifyDriverDocuments(payload)
        .then(() => {
          getDriverDocuments(id, { documents: requiredDocs });
        })
        .catch((_error) => {
          setSaveState(false);
        })
        .finally(() => {
          setTriggerDirectUpload(false);
        });
    }
  };

  const handleProfileImgSubmit = (payload) => {
    const err = validateDriverDocuments(uploadingFiles);
    setErrors(err);
    if (err.length > 0) {
      setSaveState(false);
    } else {
      setTriggerDirectUpload(true);
      updateDriverDocumentsDetails(id, uploadingFiles, action)
        .then((_response) => {
          setSaveState(false);
          getDriverDocuments(id, { documents: requiredDocs });
        })
        .catch((_error) => {
          setSaveState(false);
        })
        .finally(() => {
          setTriggerDirectUpload(false);
        });
    }
  };
  const handleSubmit = () => {
    const payload = {
      action_reason_id: reasonId,
    };
    if (action === "notify") {
      notifyDriver(id, notifyState);
    } else if (action === "resign") {
      resignDriver(id, payload);
    } else if (action === "force_offline") {
      forceOfflineDriver(id);
    } else if (action === "clear_selfie_campaign") {
      clearSelfieCampaignDriver(id);
    } else if (action === "verify") {
      if (allMenuActions.DRIVER_DOCUMENTS_EDIT) {
        handleDocumentSubmit({ driver_id: id });
      } else {
        handleDocumentsVerify({ driver_id: id });
      }
    } else if (action === "upload_profile_image") {
      handleProfileImgSubmit({ driver_id: id });
    } else {
      terminateDriver(id, payload);
    }
    handleClose();
  };

  const handleChange = (key, val) => {
    setReasonId(val);
  };

  const handleNotifyStateChange = (key, val) => {
    const values = { ...notifyState };
    values[key] = val;
    setNotifyState(values);
  };

  const handleDisabled = (value) => {
    setSubmitDisabled(value);
  };

  const checkIfButtonDisabled = () => {
    let disabled = false;
    if ((action === "terminate" || action === "resign") && !reasonId) {
      disabled = true;
    } else if (action === "notify") {
      return !isObjectAllEntriesPresent(notifyState);
    } else if (action === "verify" || action === "upload_profile_image") {
      return submitDisabled;
    }
    return disabled;
  };

  useEffect(() => {
    let newAction = "";
    if (action === "terminate") {
      newAction = "EXIT_FORMALITY_TERMINATE";
    } else if (action === "resign") {
      newAction = "EXIT_FORMALITY_RESIGN";
    }
    getDriverDocuments(id, { documents: requiredDocs });
    newAction && getDriverActionReasons(newAction);
  }, [action]);

  const getFields = (action) => {
    switch (action) {
      case "terminate":
      case "resign":
        return (
          <PaginatedReactDropdown
            options={driverActionReasons}
            labelKey="reason"
            valueKey="id"
            handleChange={handleChange}
            placeholder="Select reason"
            labelWidth="18%"
            keyToChange={reasonId}
            showCross={true}
            id={`actionReasonDropdown_${action}`}
          />
        );
      case "notify":
        return (
          <React.Fragment>
            <PaginatedReactDropdown
              options={["DASHBOARD_DRIVER_NOTIFY_INAPP"]}
              handleChange={handleNotifyStateChange}
              placeholder="Select type"
              labelWidth="18%"
              keyToChange="type"
              value={notifyState.type}
              showCross={true}
              id={`actionReasonDropdown_${action}`}
            />
            <Input
              borderColor={variables.primaryColor}
              id="sushi-input"
              fullWidth={true}
              label="Title"
              onChange={(e) => handleNotifyStateChange("title", e)}
              value={notifyState.title}
            />
            <Textarea
              id="sushi-textarea"
              borderColor={variables.primaryColor}
              innerWidth="100%"
              className="mb-20"
              resize="none"
              label="Message"
              onChange={(e) => handleNotifyStateChange("message", e)}
              value={notifyState.message}
            />
          </React.Fragment>
        );
      case "force_offline":
      case "clear_selfie_campaign":
        return <h3 className="medium mb-20">Are you sure?</h3>;
      case "verify":
        return (
          <VerifyDriverDocument
            action="verify"
            documents={driverDocuments}
            editState={editState}
            saveState={saveState}
            setUploadingFiles={setUploadingFiles}
            uploadingFiles={uploadingFiles}
            errors={errors}
            setErrors={setErrors}
            triggerDirectUpload={triggerDirectUpload}
            setSaveState={setSaveState}
            onChange={handleDisabled}
            handleAfterSave={handleEditCancel}
            setTriggerDirectUpload={setTriggerDirectUpload}
          />
        );
      case "upload_profile_image":
        return (
          <VerifyDriverDocument
            action={"upload_profile_image"}
            documents={{}}
            editState={editState}
            saveState={saveState}
            setUploadingFiles={setUploadingFiles}
            uploadingFiles={uploadingFiles}
            errors={errors}
            setErrors={setErrors}
            triggerDirectUpload={triggerDirectUpload}
            setSaveState={setSaveState}
            onChange={handleDisabled}
            handleAfterSave={handleEditCancel}
            setTriggerDirectUpload={setTriggerDirectUpload}
          />
        );
      default:
        return "";
    }
  };

  switch (action) {
    case "verify": {
      return (
        <NoFooterModal
          header
          heading={"Verify Driver"}
          handleClose={handleClose}
          id="driverActionModal"
          modalButtons={
            <BottomSectionModal>
              <Button
                data-testid="confirm-btn"
                onClick={handleSubmit}
                className="sushi-btn"
                disabled={submitDisabled}
              >
                Verify
              </Button>
            </BottomSectionModal>
          }
        >
          {getFields(action)}
        </NoFooterModal>
      );
    }
    case "upload_profile_image": {
      return (
        <NoFooterModal
          header
          heading={"Upload Profile Image"}
          handleClose={handleClose}
          id="driverActionModal"
          modalButtons={
            <BottomSectionModal>
              <Button
                data-testid="confirm-btn"
                onClick={handleSubmit}
                className="sushi-btn"
                disabled={submitDisabled}
              >
                Upload
              </Button>
            </BottomSectionModal>
          }
        >
          {getFields(action)}
        </NoFooterModal>
      );
    }
    default: {
      return (
        <NoFooterModal
          header
          heading={`${capitalizeFirstLetter(
            action.split("_").join(" ")
          )} driver`}
          handleClose={handleClose}
          id="driverActionModal"
          modalButtons={
            <BottomSectionModal>
              <Button
                data-testid="confirm-btn"
                onClick={handleSubmit}
                className="sushi-btn"
                disabled={checkIfButtonDisabled()}
              >
                {action === "force_offline" ? "Yes" : "Submit"}
              </Button>
            </BottomSectionModal>
          }
        >
          {getFields(action)}
        </NoFooterModal>
      );
    }
  }
};

function mapStateToProps(state) {
  const { DeliveryDrivers } = state;
  return {
    driverActionReasons: DeliveryDrivers.driverActionReasons,
    driverDocuments: DeliveryDrivers.driverDocuments,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverActionReasons: bindActionCreators(
      DeliveryDriversActions.getDriverActionReasons,
      dispatch
    ),
    terminateDriver: bindActionCreators(
      DeliveryDriversActions.terminateDriver,
      dispatch
    ),
    resignDriver: bindActionCreators(
      DeliveryDriversActions.resignDriver,
      dispatch
    ),
    notifyDriver: bindActionCreators(
      DeliveryDriversActions.notifyDriver,
      dispatch
    ),
    forceOfflineDriver: bindActionCreators(
      DeliveryDriversActions.forceOfflineDriver,
      dispatch
    ),
    clearSelfieCampaignDriver: bindActionCreators(
      DeliveryDriversActions.clearSelfieCampaignDriver,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    getDriverDocuments: bindActionCreators(
      DeliveryDriversActions.getDriverDocuments,
      dispatch
    ),
    verifyDriverDocuments: bindActionCreators(
      DeliveryDriversActions.verifyDriverDocuments,
      dispatch
    ),
    updateDriverDocumentsDetails: bindActionCreators(
      DeliveryDriversActions.updateDriverDocuments,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DriverActionModal);
